import { h, Component } from "preact";
import debounce from "../../../utils/Debouce";

class Donation extends Component {
  constructor() {
    super();
    this.update = this.update.bind(this);
    this.updateDebouched = this.updateDebouched.bind(this);
  }

  update(event) {
    const { updateDonationAmount } = this.props;
    let value = Number(event.target.value);
    value = isNaN(value) ? 0 : value;
    updateDonationAmount(value);
  }

  updateSelect = event => {
    const { updateDonationAmount, showCustomDonationField } = this.props;
    const value = event.target.value;
    if (value === "other") {
      showCustomDonationField();
    } else {
      updateDonationAmount(value);
    }
  };

  updateDebouched = debounce(event => {
    this.update(event);
  }, 300);

  render({ ticket, donationOtherOption }) {
    if (ticket.hidden && !ticket.accessGranted) {
      return null;
    }
    const ticketStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };
    const ticketWrap = {
      borderBottom: "1px solid #d9d9d9",
      padding: "10px 0"
    };
    const descriptionStyle = {
      margin: "6px 0 0",
      fontSize: 14,
      color: "#5A626C",
      whiteSpace: "pre-line",
      wordBreak: "break-word"
    };
    const infoStyle = {
      flex: 1
    };

    const options =
      ticket.donationOptionsOn && ticket.donationOptions.length
        ? ticket.donationOptions.map(option => {
            return <option value={option.value}>{option.value}</option>;
          })
        : [];
    options.unshift(
      <option value={0} selected>
        0
      </option>
    );
    options.push(<option value="other">Other</option>);

    return (
      <div style={ticketWrap}>
        <div style={ticketStyle}>
          <div style={infoStyle}>
            <h4
              style={{
                margin: 0
              }}
            >
              {ticket.name}
            </h4>
            <p style={descriptionStyle}>{ticket.description}</p>
            {ticket.dateError ? (
              <p
                style={{
                  margin: 0
                }}
              >
                {ticket.dateError}
              </p>
            ) : (
              ""
            )}
          </div>
          <h4
            style={{
              margin: "0 10px 0 0"
            }}
          >
            <label for="donation">Amount: $</label>
          </h4>
          <div
            style={{
              width: 80
            }}
          >
            {ticket.donationOptionsOn && !donationOtherOption ? (
              <select
                class="form-select"
                onChange={this.updateSelect}
                onKeyUp={this.updateDebouched}
              >
                {options}
              </select>
            ) : (
              <input
                id="donation"
                class="form-input"
                type="number"
                onChange={this.update}
                onKeyUp={this.updateDebouched}
                min="0"
              />
            )}
          </div>
        </div>
        <span class="text-error">
          {ticket.errors ? ticket.errors.map(err => <p>{err}</p>) : ""}
        </span>
      </div>
    );
  }
}

export default Donation;



// WEBPACK FOOTER //
// ./routes/tickets/components/Donation.js